import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { StaticContextRoute } from '../Router';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Declaratively redirect to a non-SPA route. Works by setting the `window.location.href` when
 * running in the browser and by setting static context during SSR.
 *
 * Side-effect only - renders nothing to the DOM.
 */
const RedirectExternal = props => {
  const {
    statusCode = 302,
    url
  } = props;
  useEffect(() => {
    // effects only run on the browser
    window.location.href = url;
  }, []);
  if (__REACT_SSR__) {
    // during SSR we want to set the static context by rendering the route
    // without any actual content
    return /*#__PURE__*/_jsx(StaticContextRoute, {
      statusCode: statusCode,
      url: url,
      render: () => /*#__PURE__*/_jsx(Redirect, {
        to: url
      })
    });
  }
  return null;
};
export default RedirectExternal;